(() => {
  const COMPANY_ID = 'VZC4PW';
  const EMAIL_LIST_ID = 'WJB2v5';
  const SOURCE_KEY = 'ff_first_source';
  const COLLECTION_KEY = 'ff_first_collection_viewed';

  const stored = (key) => {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  };

  const remember = (key, value) => {
    if (!value || stored(key)) return stored(key);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return value;
    }
    return value;
  };

  const identify = (properties) => {
    const payload = Object.fromEntries(
      Object.entries(properties).filter(([, value]) => value)
    );
    if (!Object.keys(payload).length) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['identify', payload]);
  };

  const subscribe = async (email, source, properties = {}) => {
    const address = String(email || '').trim();
    if (!address || !source) return false;
    const firstSource = remember(SOURCE_KEY, source);
    const profileProperties = {
      ...properties,
      first_source: firstSource,
      first_collection_viewed: stored(COLLECTION_KEY),
    };
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${COMPANY_ID}`, {
      method: 'POST',
      keepalive: true,
      headers: {
        revision: '2026-07-15',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: address,
                  properties: profileProperties,
                },
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: EMAIL_LIST_ID },
            },
          },
        },
      }),
    });
    identify({
      $email: address,
      first_source: firstSource,
      first_collection_viewed: stored(COLLECTION_KEY),
      ...properties,
    });
    return response.ok;
  };

  const collectionTitle = document.body.dataset.collectionTitle;
  if (collectionTitle && !stored(COLLECTION_KEY)) {
    remember(COLLECTION_KEY, collectionTitle);
    identify({ first_collection_viewed: collectionTitle });
  }

  document.querySelectorAll('.newsletter-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const email = form.querySelector('input[type="email"]')?.value;
      subscribe(email, 'footer').catch(() => {});
    });
  });

  document.querySelectorAll('[data-back-in-stock-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = form.parentElement?.querySelector('[data-back-in-stock-status]');
      const email = form.querySelector('input[type="email"]')?.value;
      const variantId = form.querySelector('[data-back-in-stock-variant]')?.value;
      if (status) status.textContent = '';
      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`, {
          method: 'POST',
          headers: {
            revision: '2026-07-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: String(email || '').trim() },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        });
        if (!response.ok) throw new Error('back-in-stock');
        const firstSource = remember(SOURCE_KEY, 'back_in_stock');
        identify({
          $email: String(email || '').trim(),
          first_source: firstSource,
        });
        if (status) status.textContent = 'We’ll email you when it’s back.';
        form.reset();
      } catch (error) {
        if (status) status.textContent = 'We couldn’t save that email. Please try again.';
      }
    });
  });

  const passport = document.querySelector('[data-profile-form]');
  if (passport) {
    const consent = passport.querySelector('[data-marketing-consent]');
    const emailField = passport.querySelector('[data-marketing-email]');
    consent?.addEventListener('change', () => {
      if (emailField && emailField.type === 'email') emailField.required = consent.checked;
    });
    passport.addEventListener('submit', () => {
      if (!consent?.checked) return;
      const petType = String(passport.elements.pet_type?.value || '').toLowerCase();
      const size = passport.elements.size_category?.value || '';
      const mappedType = petType.startsWith('dog') ? 'dog' : petType.startsWith('cat') ? 'cat' : '';
      subscribe(emailField?.value, 'pet_passport', {
        pet_type: mappedType,
        pet_size: size,
      }).catch(() => {});
    });
  }
})();
